import './free_text_user_profile_attribute_view.js.coffee'

class Customer.DateUserProfileAttributeView extends Customer.FreeTextUserProfileAttributeView
  className: 'user-profile-attribute date-user-profile-attribute'
  inputType: 'date'

  appendValue: (value) =>
    super.find('.input').datepicker(
      autoclose: true
      format: 'yyyy-mm-dd'
      todayBtn: 'linked'
      todayHighlight: true
      changeMonth: true
      changeYear: true
    ).on('changeDate', (event) =>
      @model.set('value', event.date.toISOString())
    )

  updateDisabled: =>
    super
    @$el.find('.input[readonly]').addClass('disabled')
    @$el.find('.input:not([readonly])').removeClass('disabled')

  afterRender: ->
